import useSWR, { mutate as globalMutate } from 'swr'
import { fetchMe } from './auth'
import { fetchUserByUsername } from './profile'
import {
  getString,
  listComments,
  listMyStrings,
  listStrings,
  listUserStrings,
} from './strings'

const FEED_LIMIT = 50

export const KEYS = {
  feed: 'strings' as const,
  string: (id: string) => ['string', id] as const,
  comments: (id: string) => ['comments', id] as const,
  me: 'auth/me' as const,
  user: (u: string) => ['user', u] as const,
  myStrings: 'users/me/strings' as const,
  userStrings: (u: string) => ['user-strings', u] as const,
}

const ttl = (ms: number) => ({ dedupingInterval: ms, revalidateOnFocus: false })

export const useFeed = () =>
  useSWR(KEYS.feed, () => listStrings(FEED_LIMIT), {
    dedupingInterval: 30_000,
    revalidateOnFocus: true,
    refreshInterval: 60_000,
  })

export const useString = (id: string) =>
  useSWR(KEYS.string(id), () => getString(id), ttl(10_000))

export const useComments = (id: string) =>
  useSWR(KEYS.comments(id), () => listComments(id), ttl(10_000))

export const useMe = (enabled: boolean) =>
  useSWR(enabled ? KEYS.me : null, fetchMe, ttl(60_000))

export const useUserProfile = (username: string) =>
  useSWR(
    username ? KEYS.user(username) : null,
    () => fetchUserByUsername(username),
    ttl(60_000),
  )

export const useMyStrings = (enabled: boolean) =>
  useSWR(enabled ? KEYS.myStrings : null, () => listMyStrings(), ttl(30_000))

export const useUserStrings = (username: string) =>
  useSWR(
    username ? KEYS.userStrings(username) : null,
    () => listUserStrings(username),
    ttl(30_000),
  )

export const invalidate = {
  feed: () => globalMutate(KEYS.feed),
  string: (id: string) => globalMutate(KEYS.string(id)),
  comments: (id: string) => globalMutate(KEYS.comments(id)),
}
